import BaseIconButton from 'components/atoms/base-icon-button';
import NoteIcon from 'assets/img/note.svg?react';

import s from './styles.module.scss';

import type { FC } from 'react';

interface NoteCellProps {
  text: string;
  onClick: () => void;
}

const NoteCell: FC<NoteCellProps> = ({ text, onClick }) => {
  return (
    <div className={s.note}>
      <span dangerouslySetInnerHTML={{ __html: text }} />
      <BaseIconButton
        className={s['note-button']}
        icon={
          <NoteIcon
            width={18}
            height={18}
            className={s['note-icon']}
            onClick={onClick}
          />
        }
      />
    </div>
  );
};
export default NoteCell;
